export default __webpack_public_path__ + "static/media/windshield-washer-fluid.f907db7b.png";